import {Component, Input, OnInit, Optional} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AbstractComponent} from "@components";
import {CompetitorResults, CompetitorStageDetail, CompetitorStatus, Race, Waypoint} from "@model";

@Component({
  selector: 'app-result-details-modal',
  templateUrl: './results-details-modal.component.html',
  styleUrl: './results-details-modal.component.scss'
})
export class ResultsDetailsModalComponent extends AbstractComponent implements OnInit {
  @Input() competitorResults!: CompetitorResults;
  @Input() measurementType: number | undefined = undefined;
  @Input() category: number | undefined = undefined;
  @Input() gender: number | undefined = undefined;
  @Input() isRoundRace:boolean = false;
  @Input() race?:Race;
  @Input() waypointList: Waypoint[] = [];

  list: CompetitorStageDetail[] = [];
  checkpointsIds: string[] = [];
  sgsFinishItem: CompetitorStageDetail | undefined;
  SGS?: { [key: string]: CompetitorStageDetail };
  constructor(@Optional() public activeModal: NgbActiveModal) {
    super();
  }

  ngOnInit() {
    if (this.competitorResults.competitorResultsDetail?.SGS && !this.isRoundRace) {
      this.SGS = this.competitorResults.competitorResultsDetail.SGS;
      this.checkpointsIds = Object.entries(this.SGS).map(([key, value]) => ({ ...value, cp_id:key }))
        .filter((item) => item.tp !== this.FINISH_CONTROL_POINT_TYPE)
        .sort((a, b) => {
          const timeA = new Date(a.ps_tm!).getTime() + (a.ps_dc || 0);
          const timeB = new Date(b.ps_tm!).getTime() + (b.ps_dc || 0);
          return timeA - timeB;
        }).map((item) => item.cp_id!);

      this.sgsFinishItem = Object.values(this.SGS).find((item) => item.tp === this.FINISH_CONTROL_POINT_TYPE);
    } else if (this.competitorResults.competitorResultsDetail?.laps && this.isRoundRace) {
      const items: CompetitorStageDetail[] = Object.entries(this.competitorResults.competitorResultsDetail.laps).map(([key, value]) => ({ ...value, lp:Number(key) }));
      this.list = items
        .sort((a, b) => a.lp! - b.lp!);
    }

  }

  onClose() {
    this.activeModal.close();
  }

  private readonly FINISH_CONTROL_POINT_TYPE = 99;

  protected readonly CompetitorStatus = CompetitorStatus;
}
